import React from "react";
import Avatar from "@mui/material/Avatar";

export default function AvatarGallery({ length }) {
  return (
    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
      {[...Array(length)].map((_, index) => (
        <div key={index} style={{ position: "relative" }}>
          <Avatar
            sx={{ height: 100, width: 100 }}
            alt={`+`}
            src={`url_for_avatar_${index + 1}.jpg`}
            variant="rounded"
          />
        </div>
      ))}
    </div>
  );
}
